import Sites from "../constants/Sites";
import { readCookie } from "./Helper";

export const makeGetRequest = ({
  type,
  siteId = Sites.EARLYBIRDBOOKS,
  query,
  pageNumber,
  slug,
  searchKeyword,
  APIType,
  ormtoken,
  asPath,
  sailthru_hid,
}) => {
  let pageSize, pageType;
  switch (type) {
    case "BookDetail":
      if (siteId === Sites.OPENROADMEDIA) {
        if (query.BookDetail.length > 1)
          return {
            urls: [
              { Book: `book/${query.BookDetail[0]}/${query.BookDetail[1]}` },
              {
                BookPromopriceData: `book/promotion/price/${query.BookDetail[1]}`,
              },
            ],
          };
        else return { urls: [{ Book: `book/${query.BookDetail[0]}` }] };
      } else {
        return { urls: [] };
      }
    case "Post":
      if (query.post.length > 1) {
        if (query.post[0] === "preview") {
          if (query.category) {
            return {
              urls: [
                { Post: `preview/detail/${query.post[1]}?token=${ormtoken}` },
                {
                  RecommededBooksPromos: `books/recommendation/${query.category}?pagesize=25`,
                },
              ],
            };
          } else {
            return {
              urls: [{ Post: `preview/detail/${query.post[1]}?token=${ormtoken}` }],
            };
          }
        } else {
          let slug = asPath.replace(/^[\\/]+|[\\/]+$/g, "");
          pageSize = 20;
          let urls = [{ Post: `post/${siteId}?slug=${slug}` }];
          if (process.env.ENABLE_READNEXT === "true") {
            urls.push({
              Recommendation: `external/esp/readnext/${siteId}/${sailthru_hid}`,
            });
          }
          return { urls, pageSize };
        }
      } else if (query.q) {
        return {
          urls: [
            { Post: `post/${siteId}?slug=${query.post}` },
            { GiveawayPage: `book/detail/id/${query.q}` },
          ],
        };
      } else {
        pageSize = 20;
        let urlList = {
          urls: [{ Post: `post/${siteId}?slug=${query.post}` }],
          pageSize,
        };
        if (sailthru_hid && process.env.ENABLE_READNEXT === "true") {
          urlList.urls.push({
            Recommendation: `external/esp/readnext/${siteId}/${sailthru_hid}`,
          });
        }

        return urlList;
      }
    case "CategoryFunnel":
      return {
        urls: [
          { Post: `post/${siteId}/slug/signup/${slug}` },
          { RecommededBooksPromos: `books/recommendation/${slug}?pagesize=25` },
        ],
      };
    case "Category":
      ((pageSize = 20), (pageType = `posts/${siteId}`));
      if (siteId === Sites.OPENROADMEDIA) {
        pageSize = 40;
        pageType = "books";
      }
      return {
        urls: [
          {
            Category: `${pageType}/category/${slug}?pagesize=${pageSize}&pagenumber=${pageNumber}`,
          },
        ],
        pageSize,
      };
    case "Rss":
      ((pageSize = 10), (pageType = `posts/${siteId}`));
      return { urls: [{ Rss: `${pageType}` }], pageSize };
    case "Contributor":
      if (siteId === Sites.OPENROADMEDIA) {
        return { urls: [{ ContributorDetail: `books/contributor/${slug}` }] };
      } else {
        return { urls: [] };
      }
    case "Publisher":
      pageSize = 40;
      if (siteId === Sites.OPENROADMEDIA) {
        return {
          urls: [
            {
              Publisher: `books/publisher/${slug}/?pagesize=${pageSize}&pagenumber=${pageNumber}`,
            },
          ],
          pageSize,
        };
      } else {
        return { urls: [] };
      }
    // case 'PublisherHome':
    //   return { urls: [{ PublisherHome: `publishers` }] };
    case "AuthorPage":
      pageSize = 20;
      return {
        urls: [
          {
            AuthorPage: `posts/${siteId}/author/${slug}/?pagesize=${pageSize}&pagenumber=${pageNumber}`,
          },
        ],
        pageSize,
      };
    case "TagsPage":
      pageSize = 20;
      return {
        urls: [
          {
            TagsPage: `posts/${siteId}/tag/${slug}/?pagesize=${pageSize}&pagenumber=${pageNumber}`,
          },
        ],
        pageSize,
      };
    case "Index": {
      const urlList = [{ Index: `post/${siteId}?slug=homepage` }];
      if (siteId === Sites.EARLYBIRDBOOKS) {
        urlList.push({
          RecentPosts: `posts/${Sites.EXPLORETHEARCHIVE}/category/Books?pagesize=2`,
        });
      }
      return { urls: urlList };
    }
    case "FeedBackPage":
      if (query.ldlOutsideBook) {
        return {
          urls: [
            {
              RecommededBooks: `books/ldloutsidebookrecommendations`,
            },
            {
              tokenValidity: `download/checktokenvalidity?token=${query.token}`,
            },
          ],
        };
      } else {
        if (query.q && query.category && query.token) {
          return {
            urls: [
              { FeedBackPage: `book/detail/id/${query.q}?ldl=true` },
              {
                RecommededBooks: `books/recommendation/${query.q}`,
              },
              {
                tokenValidity: `download/checktokenvalidity?token=${query.token}`,
              },
            ],
          };
        }
      }

      return { urls: [] };
    case "Search":
      if (APIType && APIType == "auto") {
        return {
          url: `search/${siteId}?term=${searchKeyword}&type=${APIType}`,
        };
      } else {
        pageSize = 20;
        APIType = "result";
        if (siteId === Sites.OPENROADMEDIA) {
          pageSize = 10;
          return {
            urls: [
              {
                Search: `external/search/${siteId}?term=${
                  searchKeyword ? searchKeyword : query.search
                }&pagesize=${pageSize}&pagenumber=${pageNumber}`,
              },
            ],
            pageSize,
          };
        }
        return {
          urls: [
            {
              Search: `search/${siteId}?term=${
                searchKeyword ? searchKeyword : query.search
              }&type=${APIType}&pagesize=${pageSize}&pagenumber=${pageNumber}`,
            },
          ],
          pageSize,
        };
      }
    case "article":
      pageSize = 20;
      if (siteId === Sites.OPENROADMEDIA) {
        pageSize = 10;
        return {
          urls: [
            {
              Search: `external/search/${siteId}?term=openroadmedia&pagesize=${pageSize}&pagenumber=${pageNumber}`,
            },
          ],
          pageSize,
        };
      } else {
        return {
          urls: [
            {
              article: `search/posts/${siteId}?pagesize=${pageSize}&pagenumber=${pageNumber}`,
            },
          ],
          pageSize,
        };
      }
    case "ReadingPreferences":
      return {
        urls: [
          { User: `user?token=${ormtoken}` },
          { CustomCategories: `customcategories?bygroup=true` },
        ],
      };
    case "WelcomePage":
      return { urls: [{ User: `user?token=${ormtoken}` }] };
    case "Profile": {
      // user subscriptions list is managed via an admin-protected endpoint
      // use server access key for lookup and keep user token for user-specific data
      const subscriptionLookupToken = process.env.ACCESS_KEY_ID || ormtoken;
      return {
        urls: [
          { User: `user?token=${ormtoken}` },
          {
            UserSubscriptions: `admin/usersubscriptions?token=${encodeURIComponent(subscriptionLookupToken || "")}`,
          },
        ],
      };
    }
    case "FollowAuthor":
      if (query?.fid && parseInt(query?.fid)) {
        return {
          urls: [
            { Deals: `deals/${siteId}?dp=true&fid=${query?.fid}` },
            { Books: `books/contributor/${query?.fid}/${siteId}` },
          ],
        };
      }
      break;
    case "NewsletterDealsAd":
      if (query?.ISBN) {
        const shouldShowBookshop = process.env.SHOW_BOOKSHOP === "true";
        const requiredRetailers = [
          "amazon",
          "b&n",
          ...(shouldShowBookshop ? ["bookshop"] : []),
          "apple",
          "google",
          "kobo",
        ];
        const queryParams = requiredRetailers.map(encodeURIComponent).join(",");
        //this is calling /book/:title/:isbn? route. The title is hardcoded here, as we are omitting title if isbn is passed to the backend
        return {
          urls: [
            { Books: `book/title/${query?.ISBN[0]}` },
            {
              RetailerLinks: `books/generateretailerlinks/${query?.ISBN[0]}/${siteId}?affiliateTagType=retailer&requiredRetailers=${queryParams}`,
            },
          ],
        };
      }
      break;
    case "SimilarTitles":
      if (query.isbn) {
        return {
          urls: [{ SimilarTitleSource: `book/isbn/${query.isbn}` }],
        };
      }
      return { urls: [] };
    default:
      return { urls: [] };
  }
};

export const makePostRequest = ({ type, siteId }) => {
  const token = readCookie("ormtoken");
  switch (type) {
    case "SignUp":
      return { url: `signup/${siteId}` };
    case "Login":
      return { url: "login" };
    case "LoginV2":
      return { url: "login/v2" };
    case "Forgot-Password":
      return { url: "forgotpassword" };
    case "Reset-Password":
      return { url: "resetpassword" };
    case "GetePubMobiUrls":
      return { url: "download/dbl" };
    case "UpdateProfile":
      return { url: `updateprofile?token=${token}` };
    case "SubscriptionServices":
      return { url: `admin/usersubscriptions?token=${token}` };
    case "SendEmail": {
      const accessToken = token != undefined ? token : process.env.ACCESS_KEY_ID;
      return { url: `sendemail?token=${accessToken}` };
    }
    case "UnSubscribe":
      return { url: `user/unsubscribe?token=${token}` };
    case "authorFollow":
      return { url: `author/follow/${siteId}` };
    case "authorUnFollow":
      return { url: `author/unfollow/${siteId}?token=${token}` };
    case "authorReFollow":
      return { url: `author/refollow/${siteId}?token=${token}` };
    case "gverify":
      return { url: `google/verify` };
    case "searchRetailerLinks":
      return { url: `books/generateretailerlinks?affiliateTagType=search` };
    case "generateDownloadLink":
      return { url: `download/generatedownloadlink` };
    case "LDLRedemption":
      return { url: `books/details` };
    case "ldlOutsideBook":
      return { url: "download/generatedownloadlink" };
    // case "googleReCaptcha":
    //   return {url: `https://www.google.com/recaptcha/api/siteverify?secret=6LcRYKAaAAAAAOXQnTylJcejcjLvMnMqW6ObqTkT`}
  }
};
